import { FC } from 'react';

const IndicatorSeparator: FC<{}> = () => null;

export default IndicatorSeparator;
